import axios from "axios";
import store from "@/js/store/store";

// 得到url前缀
const service = axios.create({
  // baseURL: '/api',
  baseURL: "",
  timeout: 5000
});

// // 配置axios
// axios.defaults.baseURL = '/api'
// axios.defaults.transformRequest = [function (data) {
//   return Qs.stringify(data)
// }]

// export default{
//   //得到图片文件夹路径，存到web项目下。需要使用虚拟目录
//   getConfig: async function () {
//     getImgFolderConfig();
//     getNewsHost();
//   },
// }

//获取图片文件夹虚拟路径
export async function getImgFolderConfig() {
  //测试环境
  if (process.env.NODE_ENV == "development") {
    store.dispatch(
      "globalConfig/saveImgFolderPath",
      // "http://10.14.7.215:59995/img/"
      //"http://localhost:9099/imgFolderPath/"
      "http://localhost:59996/img/"
    );
  }
  //生产环境
  else {
    const res = await service.get("../../static/config/config.json");
    store.dispatch("globalConfig/saveImgFolderPath", res.data.imgFolderPath);
  }
}

//获取websocketurl
export async function getWebSocketUrl() {
  return new Promise(async (resolve, reject) => {
    //测试环境
    if (process.env.NODE_ENV == "development") {
      await store.dispatch(
        "globalConfig/saveWebSocketUrl",
        // "ws://10.14.7.13:9008"
        "wss://wss.hyjtkj.com"
      );
      resolve();
    }
    //生产环境
    else {
      var res = await service.get("../../static/config/config.json");
      await store.dispatch("globalConfig/saveWebSocketUrl", res.data.socketUrl);
      resolve(res);
    }
  })
}

export async function getWebApiUrl() {
  return new Promise(async (resolve, reject) => {
    //测试环境
    if (process.env.NODE_ENV == "development") {
      await store.dispatch(
        "globalConfig/saveWebApiUrl",
        "http://localhost:59638/"
      );
      resolve();
    }
    //生产环境
    else {
      var res = await service.get("../../static/config/config.json");
      await store.dispatch("globalConfig/saveWebApiUrl", res.data.webApiUrl);
      resolve(res);
    }
  })
}

//获取新闻页面host
export async function getNewsHost() {
  const res = await axios.post("/News/GetNewsHost", {});
  store.dispatch("globalConfig/saveNewsHost", res.data.Data).then(res => {
    console.log(res);
    if (res.data.Code == "10000") {
    }
  });
}

//获取过滤敏感词数组
export async function sensitiveWordsArray() {
  //console.log(store.state.systemSetting.SensitiveWordsArray);
  if (localStorage.getItem("SensitiveWordsArray") == null) {
    const res = await axios.post("/SystemAppSettings/QuerySensitiveWordsArray", {});
    localStorage.setItem("SensitiveWordsArray", res.data.Data);
  }
}



// WEBPACK FOOTER //
// ./src/js/globalConfig.js